<template>
	<div>

		<flEditarVisualizar v-if="exibeStatus" :item="item" :editar="editar" @click-editar="(item) => $emit('click-editar', item)" />

		<div class="row" v-if="_existe(item.descricaoSubstituida)">
			<div class="col-md-12">
				<p style="color: red" v-if="item.descricaoSubstituida != null && item.descricaoSubstituida != ''">SUBSTÍTUIDA - NUMBER: {{item.descricaoSubstituida}}</p>
			</div>
		</div>

		<div class="row">

			<div class="col-md-2">
				<small v-if="exibeLegenda && _existe(item.taskNumber)" style="color: #777">(Task Number)<br/></small>
				<p v-if="item.taskNumber != null && item.taskNumber != ''">{{item.taskNumber}}</p>
			</div>

			<div class="col-md-8">
				<small v-if="exibeLegenda && _existe(item.taskTitle)" style="color: #777">(Task Title)<br/></small>
				<p v-if="item.taskTitle != null && item.taskTitle != ''">{{item.taskTitle}}</p>
			</div>
		</div>
		<div class="row">

			<div class="col-md-2" v-if="exibeLegenda && _existe(item.c1)">
				<small  style="color: #777">(Issue Date)<br/></small>
				<p v-if="item.c1 != null && item.c1 != ''">{{item.c1}}</p>
			</div>

			<div class="col-md-2" v-if="exibeLegenda && _existe(item.c2)">
				<small  style="color: #777">(Effective Date)<br/></small>
				<p v-if="item.c2 != null && item.c2 != ''">{{item.c2}}</p>
			</div>

			<div class="col-md-2" v-if="exibeLegenda && _existe(item.c7)">
				<small  style="color: #777">(Issued By)<br/></small>
				<p v-if="item.c7 != null && item.c7 != ''">{{item.c7}}</p>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<small v-if="exibeLegenda && _existe(item.c3)" style="color: #777">(Approval Holder/type designation)<br/></small>
				<p>{{item.c3}}</p>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<small v-if="item.anexoInspecao.length > 0" style="color: #777">(Arquivos)<br/></small>
				<p v-for="(anexo, index) in item.anexoInspecao" :key="index">
					<a style="color:#1E88E5"
						v-if="!anexo.excluir"
						v-tooltip="'Clique para visualizar o arquivo'" :href="anexo.url" target="_blank">
						{{anexo.nomeArquivo}}
					</a>

					<a class="text-danger"
						v-if="anexo.excluir"
						v-tooltip="'Clique para visualizar o arquivo'" :href="anexo.url" target="_blank">
						(EXCLUÍDO) {{anexo.nomeArquivo}}
					</a>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import flEditarVisualizar from './editar-visualizar.vue'
export default {

	components: {
		flEditarVisualizar
	},


	props: {
		item: {
			required: true,
			type: Object,
		},

		editar: {
			type: Boolean,
			required: false,
			default: true,
		},

		exibeLegenda: {
			required: true,
			type: Boolean,
		},

		exibeStatus: {
			type: Boolean,
			required: false,
			default: true,
		},
	}
}
</script>




// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/templates/AD_EASB_ASB.vue